<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import type { GdprProps } from "./GdprProps.js";
	import translations from "./Gdpr.translations.json";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { getTenant } from "../getTenant.js";
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	type $$Props = GdprProps;

	const translate = getTranslate(translations);

	const { WEB_URL } = getGlobalSettings();

	const tenant = getTenant();
</script>

<Layout>
	<section class="container flex flex-col pb-8 md:items-center">
		<div class="lg:w-[50rem]">
			<h1 class="m-0 mb-4 p-0 font-normal lg:mb-7 lg:leading-[3.25rem]">
				{translate("headline")}
			</h1>
		</div>
		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("gatheredDataTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("gatheredData1")} <a href={WEB_URL}>{WEB_URL.slice("https://".length)}</a>
				{translate("gatheredData2")}
			</p>
		</div>
		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("dataTransferTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("dataTransfer1")}</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("dataTransfer2")}</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("dataTransfer3")} <a href="mailto:{translate('email')}">{translate("email")}</a>
				{translate("dataTransfer4")}
			</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("thirdPartyTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("thirdParty")}</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("googleAnalyticsTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("googleAnalytics1")}
			</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("googleAnalytics2")}
			</p>
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">
				{translate("googleAnalytics3")}
				<a href="http://www.google.com/intl/{tenant.locale}/privacy/privacy-policy.html" target="_blank"
					>policies.google.com/privacy</a
				>.
			</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("cookiesTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("cookies")}</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("changesTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("changes")}</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("behaviorTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("behavior")}</p>
		</div>

		<div class="mb-3 w-full lg:mb-5 lg:w-[50rem]">
			<h2 class="text-2md mb-0 text-start font-medium uppercase lg:mt-4 lg:leading-7">
				{translate("liabilityTitle")}
			</h2>
		</div>
		<div class="lg:w-[50rem]">
			<p class="mb-3 text-xs lg:mb-[0.95rem] lg:leading-[1.4rem]">{translate("liability")}</p>
		</div>
	</section>
</Layout>
